import { render, staticRenderFns } from "./MotifSelection.vue?vue&type=template&id=7471c408&scoped=true"
import script from "./MotifSelection.vue?vue&type=script&lang=js"
export * from "./MotifSelection.vue?vue&type=script&lang=js"
import style0 from "./MotifSelection.vue?vue&type=style&index=0&id=7471c408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7471c408",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
